<template>
  <div class="app-container">
    <navigation-bar></navigation-bar>
    <div class="content-container">
      <div class="adventure-container">
        <h1>JOIN WATLIST</h1>
        <p>
          We are just getting started.
        </p>
        <button @click="joinWaitlist">SUBMIT</button>
      </div>
    </div>
  </div>
</template>

<script>
// 导入NavigationBar组件
import NavigationBar from '../components/NavigationBar.vue';

export default {
  data() {
    return {
      // 使用require来指定视频文件的路径
      videoSource: require('@/assets/video.mp4')
    }
  },
  components: {
    // 注册NavigationBar组件
    'navigation-bar': NavigationBar
  },
  name: 'AdventureIntro',
  methods: {
    joinWaitlist() {
      // Placeholder for the logic to join the waitlist
      alert('Thank you for your interest! We will be in touch.');
    }
  }
}
</script>


<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 使容器填满整个视口高度 */
  background-color: black; /* 设定背景色为灰色 */
}
.content-container {
  display: flex;
  flex-direction: row; /* 确保子元素横向排列，默认值是row，通常这行不是必须的 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  height: 100vh; /* 全视口高度 */
}

.adventure-container {
  color: #fff;
  width: 50%;
  text-align: center;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.adventure-container h1 {
  font-size: 5rem;
  margin-top: -2rem; /* 移除负边距或者减小值 */
  margin-bottom: 3rem;
  align-self: center; /* 确保标题居中且不影响其他元素 */
  color: #00ff66;
}

.adventure-container p {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  line-height: 2.0;
}

.adventure-container button {
  width: 230px;
  font-size: 1rem;
  padding: 1rem 2rem;
  margin-top: 10rem;
  align-self: center; /* 按钮自身居中，避免影响其他元素 */
  color: #404040;
  background-color: #fa541c;
  transition: background-color 0.3s;
  border-radius: 15px; /* 设置边框半径为20px，增大这个值可以让按钮看起来更圆 */
}


button {
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background-color: #DD4A68;
}
</style>